import axios from 'axios';
import PropTypes from 'prop-types';

const API_URL = process.env.REACT_APP_API_LOGIN;

export const requestPasswordReset = async (email) => {
  // Validar el tipo de `email`
  if (typeof email !== 'string') {
    throw new Error('El email debe ser una cadena de texto');
  }
  return axios.post(`${API_URL}/reset-password/request`, { email });
};

// Función para confirmar el restablecimiento de la contraseña con el hash
export const confirmPasswordReset = async (hash) => {
  // Validar el tipo de `hash`
  if (typeof hash !== 'string') {
    throw new Error('El hash debe ser una cadena de texto');
  }
  return axios.post(`${API_URL}/olvido-reseteo-password`, { hash });
};

requestPasswordReset.propTypes = {
  email: PropTypes.string.isRequired
};

confirmPasswordReset.propTypes = {
  hash: PropTypes.string.isRequired
};
